{
  "bicycle": "Fiets",
  "bicycle_required": "Fietskeuze is vereist",
  "body_height": "Lengte (in cm)",
  "body_height_integer": "Lichaamslengte moet een heel aantal centimers zijn",
  "body_height_positive": "Lichaamslengte moet een positief getal zijn",
  "body_height_required": "Lichaamslengte is vereist",
  "body_height_too_high": "Lichaamslengte moet minder zijn dan 300 centimeter",
  "body_height_too_low": "De lichaamslengte moet minstens 100 centimeter zijn",
  "body_height_tooltip": "Om geschikte fietsen voor u te regelen aan boord, willen we graag uw lichaamslengte in cm weten.",
  "cabin": "Hut",
  "cabin_full": "Hut heeft te veel passagiers toegewezen gekregen",
  "cabin_required": "Hutindeling is vereist",
  "city": "Stad",
  "city_required": "Stad is vereist",
  "country": "Land",
  "country_required": "Land is vereist",
  "customer_remarks": "Klantopmerkingen",
  "date_day_placeholder": "DD",
  "date_month_placeholder": "MM",
  "date_of_birth": "Geboortedatum (DD-MM-JJJJ)",
  "date_of_birth_in_past": "Geboortedatum in verleden",
  "date_of_birth_invalid": "Geboortedatum ongeldig",
  "date_of_birth_required": "Geboortedatum is vereist",
  "date_of_birth_too_far_in_the_past": "Geboortedatum te ver in het verleden",
  "date_year_placeholder": "JJJJ",
  "diet": "Dieet",
  "email_address": "E-mailadres",
  "email_address_optional": "E-mailadres (optioneel)",
  "email_address_email": "E-mailadres",
  "email_address_required": "E-mailadres is vereist",
  "email_address_undeliverable": "We konden dit e-mailadres niet verifiëren, controleer het alstublieft",
  "first_name": "Voornaam",
  "first_name_required": "Voornaam is verplicht",
  "gender": "Geslacht",
  "gender_choice": "Het geslacht moet mannelijk of vrouwelijk zijn",
  "group_name": "Groepsnaam",
  "last_name": "Achternaam",
  "last_name_required": "Achternaam is verplicht",
  "phone_number": "Telefoonnummer",
  "phone_number_optional": "Telefoonnummer (optioneel)",
  "phone_number_required": "Telefoonnummer is vereist",
  "phone_number_invalid": "Voer een geldig telefoonnummer in",
  "search_country": "Zoek land",
  "no_countries_found": "Geen landen gevonden",
  "state": "Staat/provincie",
  "state_invalid": "Staat/provincie is ongeldig",
  "state_required": "Staat/Provincie is vereist",
  "street_address": "Straat",
  "street_address_required": "Adres is vereist",
  "zip_code": "Postcode",
  "zip_code_required": "Postcode is vereist"
}
